import { Injectable } from '@angular/core';
import { LogonRequest } from '../models/logon-request.model';
import { ServiceUtil } from '../utilities/service.util';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { ImpersonationUser } from 'src/modules/studer/impersonate-user/impersonate-user.model';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';

@Injectable()
export class AccountService {
	private _controllerName: string = 'account';
    private readonly stsServer: string;

	constructor(private configService: ConfigService, private _serviceUtil: ServiceUtil, private _http: HttpClient) { 
        this.stsServer = this.configService.appSettings.idsServer;
    }

	async logon(logonReq: LogonRequest): Promise<any> {
		const loginResponse = this._http.post(
			`${ this.stsServer }/account/login`,
			JSON.stringify(logonReq))
			.toPromise();

		return loginResponse;
	}

	async logoutAsync(): Promise<any> {
		const params = new HttpParams({
			fromObject: {
				logoutId: '0'
			}
		});

		console.log('Inside logoutAsync.');
		return this._serviceUtil.doGetRequestWithParamsAsync<HttpResponse<any>>(this._controllerName, 'logout', params);
	}

	async getUserApplications(): Promise<any> {
		return this._http.get<any>(
			`${ this.stsServer }/${this._controllerName}/UserApplications`)
			.toPromise();
	}

	async getHapTokenForChildApplication(): Promise<string> {
		return await this._serviceUtil.doGetRequestAsync<string>(this._controllerName, 'GetHapTokenForChildApplication');
	}

	async getTokenForUserApplication(options: { applicationId: number, applicationUserId: number }): Promise<string> {
		var { applicationId, applicationUserId } = options;
		const params = new HttpParams({
			fromObject: {
				applicationId: `${applicationId}`,
				applicationUserId: `${applicationUserId}`,
			}
		});

		return await this._serviceUtil.doGetRequestWithParamsAsync<string>(this._controllerName, 'GetTokenForUserApplication', params);
	}

	async getTokenForImpersonation(impUser: ImpersonationUser): Promise<string>	{
		return this._serviceUtil.doPostRequestAsync<any, string>(this._controllerName, 'GetTokenForImpersonation', impUser);
	}

	async getTokenForCoachImpersonation(impUser: ImpersonationUser): Promise<string>	{
		return this._serviceUtil.doPostRequestAsync<any, string>(this._controllerName, 'GetTokenForCoachImpersonation', impUser);
	}

	 getTokenVerify(): Observable<HttpResponse<any>> {
		return this._serviceUtil.doGetRequest<HttpResponse<any>>(this._controllerName, 'Verify', );
	}

	async getStuderChildApplicationUserId(userId: number): Promise<number> {
		return await this._serviceUtil.doGetRequestAsync('Studer', `GetStuderChildApplicationUserId/${userId}`);
	}
}
